/*
 * SDK连接相关
 */

import store from '@/store'
import configs from './config'
import {onFriends, onSyncFriendAction} from './friends'
import {onMyInfo, onUserInfo} from './userInfo'
import {onSessions, onUpdateSession} from './session'
import {onRoamingMsgs, onOfflineMsgs, onMsg} from './msgs'
import {
    onTeams,
    onSynCreateTeam,
    onCreateTeam,
    onUpdateTeam,
    onTeamMembers,
    onUpdateTeamMember,
    onAddTeamMembers,
    onRemoveTeamMembers,
    onUpdateTeamManagers,
    onDismissTeam,
    onUpdateTeamMembersMute,
    onTeamMsgReceipt,
} from './team'
import * as SDK from './NIM_Web_SDK_v5.8.0'

// 重新初始化 NIM SDK
export function initNimSDK({state, commit, dispatch}, loginInfo) {
    if (state.nim) {
        state.nim.disconnect()
    }
    let ifDebug = false
    if (process.env.NODE_ENV === 'production') {
        ifDebug = false
    }
    if (process.server) {
        return
    }
    // 初始化SDK
    window.nim = SDK.NIM.getInstance({
        debug: ifDebug,
        appKey: configs.appkey,
        account: loginInfo.yunxinAccId,
        token: loginInfo.token,
        transports: ['websocket'],
        db: true,
        syncSessionUnread: true,
        syncRobots: true,
        needReconnect: true,
        shouldIgnoreNotification(msg) {
            return msg.type === 'notification'
        },
        autoMarkRead: true, // 默认为true,false时SDK就不会控制信息自动为已读
        onconnect: function onConnect(event) {
            // 连接上以后更新uid
            commit('updateAccountInfo', loginInfo)
        },
        onerror: function onError(event) {
            alert('Internal error')
        },
        onwillreconnect: function onWillReconnect() {
            console.log('reconnect')
        },
        ondisconnect: function onDisconnect(error) {
            console.log('err', error)
            switch (error.code) {
                // 账号或者密码错误, 请跳转到登录页面并提示错误
                case 302:
                    console.log('302')
                    commit('logInFailedPrompt')
                    break
                // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
                // case 417:
                //     commit('logInFailedPrompt')
                //     break;
                // 被踢, 请提示错误后跳转到登录页面
                case 'kicked':
                    console.log('kicked')
                    commit('logInFailedPrompt')
                    break
                default:
                    break
            }
        },
        // 用户关系及好友关系
        onfriends: onFriends,
        onsyncfriendaction: onSyncFriendAction,
        // 用户名片 - actions/userInfo
        onmyinfo: onMyInfo,
        onupdatemyinfo: onMyInfo,
        onusers: onUserInfo,
        onupdateuser: onUserInfo,
        // // 群组
        onteams: onTeams,
        onsynccreateteam: onSynCreateTeam,
        syncTeams: true,
        onteammembers: onTeamMembers,
        onCreateTeam,
        onDismissTeam,
        onUpdateTeam,
        onAddTeamMembers,
        onRemoveTeamMembers,
        onUpdateTeamManagers,
        onupdateteammember: onUpdateTeamMember,
        onUpdateTeamMembersMute,
        onTeamMsgReceipt,
        // 会话
        onsessions: onSessions,
        onupdatesession: onUpdateSession,
        // 消息
        onroamingmsgs: onRoamingMsgs,
        onofflinemsgs: onOfflineMsgs,
        onmsg: onMsg,
        // 同步完成
        onsyncdone: function onSyncDone() {
            // 说明在聊天列表页
            if (store.state.chat.currSessionId) {
                dispatch('setCurrSession', store.state.chat.currSessionId)
            }
            commit('setNimInitComplete', true)
        },
    })
    commit('SET_NIM', window.nim)
}

// 为了统计未读数，单独初始化一个NIM SDK
export function initUnreadNimSDK({state, commit, dispatch}, loginInfo) {
    if (process.server) {
        return
    }
    let sessionList = []
    // 初始化SDK
    const nim = SDK.NIM.getInstance({
        debug: false,
        appKey: configs.appkey,
        account: loginInfo.yunxinAccId,
        token: loginInfo.token,
        transports: ['websocket'],
        db: false,
        syncSessionUnread: true,
        syncRobots: true,
        needReconnect: true,
        shouldIgnoreNotification(msg) {
            return msg.type === 'notification'
        },
        autoMarkRead: true, // 默认为true,false时SDK就不会控制信息自动为已读
        onerror: function onError(event) {
            console.log('Internal error')
        },
        // 会话
        onsessions(list) {
            sessionList = list
            commit('SET_CHAT_UNREAD', sessionList.reduce((count, item) => (item.unread ? item.unread + count : count), 0), { root: true })
        },
        onupdatesession(session) {
            sessionList = nim.mergeSessions(sessionList, session)
            commit('SET_CHAT_UNREAD', sessionList.reduce((count, item) => (item.unread ? item.unread + count : count), 0), { root: true })
        },
    })
}
